import React, { useState, useEffect } from 'react';
import { PDFViewer, Document, Page, Text, View, StyleSheet , Font, Image} from '@react-pdf/renderer';
import EvaluationTable from './EvaluationTable';
import { useParams } from 'react-router-dom';
import { Backdrop, Typography } from '@mui/material';

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})


const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const EvaluationPDF = () => {
    
  /*const [evaluationData, setEvaluationData] = useState(null);

  useEffect(() => {
    // Fetch data from the API
    axios.get('your_api_endpoint')
      .then(response => setEvaluationData(response.data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);*/
    const userId = localStorage.getItem("userId");
    const { demoId } = useParams()
    const [evaluationData, setEvaluationData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null);
  
    

    
  
    useEffect(() => {

        const requestData = {
            user_id: parseInt(userId),
            demo_id: parseInt(demoId),
          };
      const fetchAdditionalDetails = async () => {
        try {
          setIsLoading(true);
          const response = await fetch(`${API_ENDPOINT}route/fetchevaluation`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // add any other headers you need
          },
          body: JSON.stringify(requestData),
        });
          if (response.ok) {
            const data = await response.json();
            setEvaluationData(data);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setError('Error fetching additional details');
          }
        } catch (error) {
          setIsLoading(false);
          setError('Error fetching additional details');
        }
      };
  
      fetchAdditionalDetails();
    }, []);

    const styles = StyleSheet.create({
      page: {
          fontFamily: 'Helvetica',
          fontSize: 11,
          paddingTop: 30,
          paddingLeft:60,
          paddingRight:60,
          lineHeight: 1.5,
          flexDirection: 'column',
      }, 
      section: {
          margin: 10,
          padding: 10,
          flexGrow: 1,
        },
      logo: {
          width: 170,
         
          marginLeft: 'auto',
          marginRight: 'auto'
      },
      title: {
          marginTop: 20,
          paddingBottom: 3,
        fontFamily: 'Open Sans',
          textAlign:'center',
          fontWeight:"Bold",
          fontSize:'20px'
      },
      subtitle:{fontFamily: 'Open Sans',fontSize:'14px',fontWeight:'normal'},
      text:{flexDirection:'row', alignItems:'center',fontFamily:"Open Sans", marginTop:10},
      maintext:{fontWeight:'bold', fontSize:'14px' ,}
    });
  
  const generatePDF = () => {
    // Create a PDF document
    const pdfDoc = (
      <Document>
        <Page size="A4" style={styles.page}>
        <View style={styles.logo}>
        <Image src='/Siec Logo.png' style={{width:'100%', }}/>
       </View>
            <Text style={styles.title}>Evaluation Report</Text>
{evaluationData.map((data)=>(
  <>
 <View style={{marginBottom:'20px'}}>

 <View style={styles.text}>
  <Text style={styles.subtitle}>Student Name </Text>
            <Text style={styles.maintext}>: {data?.demo_id?.enquiry_id?.first_name} {data?.demo_id?.enquiry_id?.last_name}</Text></View>

            <View style={styles.text}>
  <Text style={styles.subtitle}>Trainer Name </Text>
            <Text style={styles.maintext}>: {data?.demo_id?.trainer_id?.first_name}  {data?.demo_id?.trainer_id?.last_name}</Text></View>
        
          
            </View> 

            <EvaluationTable evaluationData={data} />
            {/* Add other evaluation data or components as needed */}
            </>
          ))}
        </Page>
      </Document>
    );

    return pdfDoc;
  };

  return (
    <div>
         <>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h2" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <img src='/sand-clock.png' alt="Error" style={{ width: '200px', height: '200px' }} />
      </Backdrop>

      {error && !isLoading &&  (
         <div
         style={{
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'center',
           alignItems: 'center',
           height: '100%',
         }}
       >
          <img src='/browser.png' alt="Error" style={{ width: '200px', height: '200px' }} />
          <Typography variant="h3">Error generating demo evaluation report</Typography>
          <Typography variant="h5">Please try again later</Typography>
        </div>
      )}
      {evaluationData && !isLoading && !error && (
         <PDFViewer style={{ width: "100%", height: "100vh" }}>
        {generatePDF()}
      </PDFViewer>
      )}
    </>
      
    </div>
  );
};

export default EvaluationPDF;